const rolesBaseUrl = `/roles`;
const roles = `${rolesBaseUrl}/allowed-to-create-roles`;
export const getRoles = roles;
